import React from 'react';
import { C, LAYOUT } from '../../shared/design-tokens.js';
import { CONTROL_INPUT, MUTED_LABEL } from './fleet-ui.js';
import type { FleetStatusCounts, TerminalOption } from './use-fleet-read-model.js';

const STATUS_OPTIONS = [
  { value: 'all',        label: 'All statuses' },
  { value: 'active',     label: 'Active' },
  { value: 'oos',        label: 'Out of service' },
  { value: 'in_transit', label: 'In transit' },
  { value: 'returned',   label: 'Returned' },
];

interface FleetContextRailProps {
  statusFilter: string;
  terminalFilter: string;
  terminalOptions: TerminalOption[];
  statusCounts: FleetStatusCounts;
  onStatusChange: (value: string) => void;
  onTerminalChange: (value: string) => void;
}

export default function FleetContextRail({ statusFilter, terminalFilter, terminalOptions, statusCounts, onStatusChange, onTerminalChange }: FleetContextRailProps) {
  return (
    <div style={LAYOUT.subPanel}>
      <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', color: C.gold, marginBottom: 12 }}>
        Fleet context rail
      </div>

      <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', marginBottom: 12 }}>
        <div>
          <label style={MUTED_LABEL}>Status scope</label>
          <select value={statusFilter} onChange={(e) => onStatusChange(e.target.value)} style={CONTROL_INPUT}>
            {STATUS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
        <div>
          <label style={MUTED_LABEL}>Terminal scope</label>
          <select value={terminalFilter} onChange={(e) => onTerminalChange(e.target.value)} style={CONTROL_INPUT}>
            {terminalOptions.map((opt: TerminalOption) => (
              <option key={opt.id} value={opt.id}>{opt.name}</option>
            ))}
          </select>
        </div>
      </div>

      <div style={{ display: 'grid', gap: 8, gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))' }}>
        {[
          { label: 'Total',       value: statusCounts.all },
          { label: 'Active',      value: statusCounts.active,     accent: C.green },
          { label: 'OOS',         value: statusCounts.oos,        accent: statusCounts.oos > 0 ? C.red : C.textMuted },
          { label: 'In transit',  value: statusCounts.in_transit, accent: statusCounts.in_transit > 0 ? C.gold : C.textMuted },
          { label: 'Rentals',     value: statusCounts.rental },
          { label: 'Open issues', value: statusCounts.issues,     accent: statusCounts.issues > 0 ? C.red : C.textMuted },
        ].map((stat) => (
          <div key={stat.label} style={{ padding: 10, borderRadius: 8, background: C.panel, border: `1px solid ${C.borderSoft}` }}>
            <div style={{ color: C.textMuted, fontSize: 11, marginBottom: 4 }}>{stat.label}</div>
            <div style={{ color: stat.accent || C.text, fontSize: 18, fontWeight: 700 }}>{stat.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
